import { UserAuthData } from './auth';

export enum LoginEvents {
  Bootstrap = 'Bootstrap',
}

export enum HostEvents {
  BusinessChange = 'BusinessChange',
}

export enum ApplicationEventsEnum {
  UserAuthData = 'UserAuthData',
  OriginSiteUrl = 'OriginSiteUrl',
  RouteChanged = 'RouteChanged',
  Redirect = 'Redirect',
  ResetAuthToken = 'ResetAuthToken',
  UserAuthDataRefreshed = 'UserAuthDataRefreshed',
}

export type UserLoginEvent = {
  type: ApplicationEventsEnum.UserAuthData;
  message: UserAuthData;
};

export type OriginSiteUrl = {
  type: ApplicationEventsEnum.OriginSiteUrl;
  message: string;
};

export type ChildRouteChanged = {
  type: ApplicationEventsEnum.RouteChanged;
  message: string;
};

export type ResetAuthToken = {
  type: ApplicationEventsEnum.RouteChanged;
  message: string;
};

export type AuthTokenRefreshed = {
  type: ApplicationEventsEnum.UserAuthDataRefreshed;
  message: UserAuthData;
};

export type RouteEvent = {
  type: ApplicationEventsEnum.RouteChanged;
  message: string;
  source: string;
}

export type NotifyChildEvent = UserLoginEvent | OriginSiteUrl | RouteEvent;

export type NotifyParentEvent = ChildRouteChanged | ResetAuthToken | UserLoginEvent;
